import type { FaireProductEntity } from "../../entity_types/product";

export const p_dqm2t3qehy: FaireProductEntity = {
  token: "p_dqm2t3qehy",
  type: "product",
  name: "Lunar Bay Over Dyed Seersucker Artisan Pants",
  brandToken: "b_5xdelgfsdc",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/445944dd3a240d691c9c7534f061196f6109bcd65e12049891a6875e89d91da3.jpeg",
  galleryImageUrls: [],
  priceDollars: 27.72,
  description:
    "Handmade with care in the magical land of Nepal, these pants are a testament to the skilled craftsmanship and vibrant spirit of the local artisans. Made with love and attention to detail, they feature an over-dyed seersucker fabric that adds a touch of whimsy and uniqueness to each pair. The one-size-fits-all design ensures a comfortable and relaxed fit for all free spirits out there. Whether you're dancing under the moonlight or embracing the natural beauty of the world, these pants will be your trusty companions, allowing you to move with grace and flow with the cosmic energy. ",
  tags: [],
  msrpDollars: 55.43,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:28.282Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
